/* =========================================================================== *\
 __      __.__     ___________           .__    ____ ________  ________.________
/  \    /  \__| ___\__    ___/___   ____ |  |__/_   /   __   \/   __   \   ____/
\   \/\/   /  |/    \|    |_/ __ \_/ ___\|  |  \|   \____    /\____    /____  \ 
 \        /|  |   |  \    |\  ___/\  \___|   Y  \   |  /    /    /    //       \
  \__/\  / |__|___|  /____| \___  >\___  >___|  /___| /____/    /____//______  /
       \/          \/           \/     \/     \/                             \/ 
\* =========================================================================== */

import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

// @mui material components
import Backdrop from "@mui/material/Backdrop";
import Icon from "@mui/material/Icon";
import Alert from "@mui/material/Alert";
import CircularProgress from "@mui/material/CircularProgress";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import Avatar from "@mui/material/Avatar";
import TableContainer from "@mui/material/TableContainer";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";

// Material Dashboard 2 PRO React examples
import { useTranslation } from "react-i18next";
import { APP_STATE } from "services/Define";
import { FetchData } from "services/Request";
import { useSelector } from "react-redux";
import * as Func from "services/Function";

const stepperName = {
  edit: {
    name: "แก้ไขข้อมูล",
    color: "warning",
    icon: "border_color",
  },
  purchase: {
    name: "สั่งซื้อ",
    color: "info",
    icon: "task_alt",
  },
  receive: {
    name: "รับบางส่วน",
    color: "info",
    icon: "task_alt",
  },
  success: {
    name: "ได้รับครบ",
    color: "success",
    icon: "task_alt",
  },
  reject: {
    name: "ยกเลิก",
    color: "error",
    icon: "cancel",
  },
};

function PurchaseRequestPO() {
  const mod = "purchase_request";
  const app = useSelector((state) => state[APP_STATE]);
  const { t, i18n } = useTranslation();
  const { id } = useParams();
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(true);

  const open = () => {
    setLoading(true);
    setList([]);

    FetchData("OPTIONS", `/${mod}/po`, app.token, {
      id: id,
      lang: app.lang,
    }).then((result) => {
      if (result.status === "ok") {
        setList(result.list);

        setLoading(false);
      }
    });
  };

  const imageDisplay = (item) => {
    return <Avatar alt={item.name} src={item.image} variant="rounded" />;
  };

  const statusDiaplay = (status) => {
    return (
      <Alert
        icon={<Icon>{stepperName[status].icon}</Icon>}
        severity={stepperName[status].color}
        sx={{
          fontSize: "14px",
          padding: "0 10px",
          fontWeight: 400,
          borderRadius: 5,
          whiteSpace: "nowrap",
        }}
      >
        {stepperName[status].name}
      </Alert>
    );
  };

  const renderLoading = () => {
    return (
      <Backdrop sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }} open={loading}>
        <CircularProgress color="inherit" />
      </Backdrop>
    );
  };

  const renderOpen = () => {
    return (
      <MDBox>
        <MDBox sx={{ border: "1px solid #e2e2e2", borderRadius: 1 }}>
          <TableContainer sx={{ boxShadow: 0 }}>
            <Table aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell align="center">No.</TableCell>
                  <TableCell align="center">รูป</TableCell>
                  <TableCell>SKU</TableCell>
                  <TableCell>สินค้า</TableCell>
                  <TableCell align="right">จำนวน</TableCell>
                  <TableCell>หน่วย</TableCell>
                  <TableCell align="center">PO</TableCell>
                  <TableCell align="center">สถานะ</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {list.map((row, i) => (
                  <TableRow key={row.id}>
                    <TableCell align="center" width="100">
                      {i + 1}
                    </TableCell>
                    <TableCell width="40">{imageDisplay(row)}</TableCell>
                    <TableCell align="left">{row.sku}</TableCell>
                    <TableCell align="left">{row.product_name}</TableCell>
                    <TableCell align="right">{Func.numberDisplay(row.quantity)}</TableCell>
                    <TableCell align="left">{row.unit_name}</TableCell>
                    <TableCell align="center">{row.po_code}</TableCell>
                    <TableCell align="center" width={160}>
                      {statusDiaplay(row.po_status)}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </MDBox>
      </MDBox>
    );
  };

  useEffect(() => {
    i18n.changeLanguage(app.lang);

    open();
  }, [id]);

  return (
    <div>
      {renderOpen()}
      {renderLoading()}
    </div>
  );
}

export default PurchaseRequestPO;
